module.exports = __webpack_public_path__ + "img/natural_oak_369m_list.0b2cd129.jpg";